import { useEffect } from "react";

const BASE = "OmniSearch";

/**
 * Sets document.title to `${pageTitle} · ${BASE}` (or just `${BASE}` if no pageTitle).
 * Also updates the meta description if `description` is provided.
 * Restores previous values on unmount.
 */
export function usePageTitle(pageTitle, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = pageTitle ? `${pageTitle} · ${BASE}` : `${BASE} — Recherchez le web, pas vous`;

    let descTag = document.querySelector('meta[name="description"]');
    const prevDesc = descTag?.getAttribute("content") ?? null;
    if (description) {
      if (!descTag) {
        descTag = document.createElement("meta");
        descTag.setAttribute("name", "description");
        document.head.appendChild(descTag);
      }
      descTag.setAttribute("content", description);
    }
    return () => {
      document.title = prevTitle;
      if (description && descTag && prevDesc !== null) {
        descTag.setAttribute("content", prevDesc);
      }
    };
  }, [pageTitle, description]);
}
